import React, { useEffect, useState } from "react";
import { useGetFetchNew } from "../../../data/Queries";
import { top_users_details } from "../../../data/ApiEndpoints";
import CommonHeadingNBtns from "../../../components/common-components/CommonHeadingNBtns";
import { convertThenFormat } from "../../../components/common-data/Converts";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import Loader from "../../../components/ui/Loader";
import FilterContainer from "../../../components/common-components/filters/filter-container";
import DateRangerFilter from "../../../components/common-components/filters/date-ranger-filter";
import { Tab, TabList, Tabs } from "react-tabs";

const TopUserDetail = ({ userInfoData, selectedUser, closeModal }) => {
  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [activeTab, setActiveTab] = useState("cr");

  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    isActive: "",
    searchString: "",
    start_date: "",
    end_date: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    start_date: "",
    end_date: "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const { data, isLoading, refetch } = useGetFetchNew({
    token: userInfoData?.token,
    key: "top_users_details",
    url: `${top_users_details}`,
    filters: {
      user_id: selectedUser?.user_id,
      type: activeTab,
      start_date: allFilters?.start_date,
      end_date: allFilters?.end_date,
      searchString: allFilters?.searchString,
    },
  });

  useEffect(() => {
    refetch();
  }, [selectedUser, filters, activeTab]);

  const handleDateChange = (start_date, end_date) => {
    setAllFilters((prev) => ({
      ...prev,
      start_date: start_date,
      end_date: end_date,
    }));
    setFilters((prev) => ({
      ...prev,
      start_date: start_date,
      end_date: end_date,
    }));
  };

  const tbColumns = [
    {
      dataField: "gym_name",
      text: <p className="table__header">Gym Name</p>,
      formatter: (cell, row) => {
        return <p>{row?.gym_name}</p>;
      },
    },
    {
      dataField: "category",
      text: <p className="table__header">Category</p>,
      formatter: (cell, row) => {
        return <p>{row?.category}</p>;
      },
    },
    {
      dataField: "coins",
      text: <p className="table__header">Coins</p>,
      formatter: (cell, row) => {
        return <p>{row?.coins}</p>;
      },
    },
    {
      dataField: "coins_inr_value",
      text: <p className="table__header">Coins Inr Value</p>,
      formatter: (cell, row) => {
        return <p>{`₹${convertThenFormat(row?.coins_inr_value)}`}</p>;
      },
    },
    {
      dataField: "date",
      text: <p className="table__header">Date</p>,
      formatter: (cell, row) => {
        return <p>{row?.date}</p>;
      },
    },
  ];

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title={`${selectedUser?.name} ${
          activeTab === "cr" ? "Earned" : "Spent"
        } History`}
        isLoading={false}
        btnTxt1={"Close"}
        onClick1={closeModal}
      />

      <br />

      <FilterContainer onReset={() => setAllFilters(iniAllFilter)}>
        <DateRangerFilter
          startDate={allFilters.start_date}
          endDate={allFilters.end_date}
          onDateChange={handleDateChange}
        />
        {/* <SearchFilter
          selectedSearch={allFilters.searchString}
          setSelectedSearch={(value) =>
            setAllFilters((prev) => ({
              ...prev,
              searchString: value,
            }))
          }
        /> */}
      </FilterContainer>

      <br />

      <Tabs
        selectedIndex={activeTab === "cr" ? 0 : activeTab === "dr" ? 1 : 2}
        onSelect={(index) =>
          setActiveTab(index === 0 ? "cr" : index === 1 ? "dr" : "")
        }
      >
        <div className="tab__Border">
          <TabList>
            <Tab>Earn</Tab>
            <Tab>Spent</Tab>
          </TabList>
        </div>
      </Tabs>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {isLoading ? (
          <div className="flexCenter" style={{ minHeight: "200px" }}>
            <Loader />
          </div>
        ) : (
          <PaymentLinkTable
            tableColumns={tbColumns}
            tableData={data?.data}
            isPage={page}
            setIsPage={(value) => setPage(value)}
            isLoading={isLoading}
            tablePagination={data?.pagination}
            setPageLimit={(value) => setPageLimit(value)}
            pageLimit={pageLimit}
          />
        )}
      </div>
    </div>
  );
};

export default TopUserDetail;
